import React, {useState} from "react";
import img from "./assets/thum.png";
import GetYouProjects from "../../../GlobalComponents/GetYouProjects/GetYouProjects";
const Offer = () => {
  const SingleSection = ({ title, des, className, link }) => {
    const handleLearn = () =>{
      window.location.href = link;
    }
    return (
      <div
        className={`flex flex-col md:flex-row gap-[20px] md:gap-[50px] ${className}`}
      >
        <div className="w-full md:w-[400px]  flex-none ">
          <img className="w-full" src={img} alt="" />
        </div>
        <div className="grow">
          <h2 className="mt-[24px] text-res-lg leading-[24px] mb-[22px] font-semibold">
            {title}
          </h2>
          <p className="text-res-xs font-medium leading-[24px]">{des}</p>
          <button onClick={handleLearn} className="flex justify-center items-center w-[173px] h-10 border p-2 rounded-[20px] border-solid border-white font-bold mt-[22px]">
            Learn More
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="container mt-[80px] md:mt-[124px]">
      <h2 className="text-center text-lg font-black">What we Offer</h2>
      <div className="mt-[75px] max-w-[840px] mx-auto flex flex-col gap-[119px]">
        <SingleSection
          link="/nft-auction"
          title={"The R34P DAO"}
          des={`Our unique Tier 1 and Tier 2 NFTs offer exclusive benefits and access to the most exciting opportunities in the DeFi space. As a member of the R34P DAO community, you'll have the chance to participate in fund raises for innovative DeFi projects and help shape the future of the industry.`}
        ></SingleSection>

        <SingleSection
          link="/marketplace"
          className="md:flex-row-reverse"
          title={"NFT Marketplace"}
          des={`Explore our curated collection of Tier 1 and Tier 2 NFTs, each offering a unique and limited-edition experience. Tier 1 NFTs represent the pinnacle of rarity and value, granting holders access to exclusive benefits and privileges within the DAO. Tier 2 NFTs provide an opportunity for broader participation, offering their own distinct features and opportunities. `}
        ></SingleSection>

        <SingleSection
          link="/forexs"
          className="md:gap-[45px]"
          title={"Forex’s Signal Service"}
          des={`Join Forex Shark's premium crypto trading signals service and unlock the potential of the digital asset market. With years of expertise and a proven track record, Forex Shark provides accurate and timely trading signals that can help you navigate the volatile cryptocurrency landscape with confidence.  `}
        ></SingleSection>

        <SingleSection
          link="/raise"
          className="md:flex-row-reverse"
          title={"The DAO Raise"}
          des={`As a participant, you'll have the opportunity to contribute to groundbreaking projects and shape the future of decentralized finance. Through our transparent and community-driven approach, we enable DAO members to pool their resources and collectively invest in projects that align with our shared vision. `}
        ></SingleSection>

        <SingleSection
          link="/forexs"
          className="md:gap-[45px]"
          title={"Distribution Contract"}
          des={`Join Forex Shark's premium crypto trading signals service and unlock the potential of the digital asset market. With years of expertise and a proven track record, Forex Shark provides accurate and timely trading signals that can help you navigate the volatile cryptocurrency landscape with confidence.   `}
        ></SingleSection>

        <SingleSection
          link="/claims"
          className="md:flex-row-reverse"
          title={"Vesting & Claims"}
          des={`As a participant, you'll have the opportunity to contribute to groundbreaking projects and shape the future of decentralized finance. Through our transparent and community-driven approach, we enable DAO members to pool their resources and collectively invest in projects that align with our shared vision. `}
        ></SingleSection>
      </div>
      <div className="max-w-[1240px] max-auto mt-[176px]">
        <GetYouProjects></GetYouProjects>
      </div>
    </div>
  );
};

export default Offer;
